import React, { useEffect, useState } from 'react'

import { doc, onSnapshot } from 'firebase/firestore'
import { useNavigate, useParams } from 'react-router-dom'

import { Button, DeleteUserButton } from '../components/buttons'
import { Section } from '../components/ContainerSection'
import ProfileView from '../components/profile/ProfileView'
import { useUser } from '../context'
import { firestore } from '../firebase/firebaseConfig'
import { AnyProfile, Person } from '../types'

const normalizeAdminProfile = (
  uid: string,
  profile: Partial<Person>,
): AnyProfile =>
  ({
    uid,
    name: profile.name ?? '',
    lastname: profile.lastname ?? '',
    phone: profile.phone ?? '',
    birthDate: profile.birthDate ?? '',
    email: profile.email ?? '',
    genre: profile.genre ?? '',
    title: profile.title ?? '',
    activities: profile.activities ?? [],
    experienceType: profile.experienceType ?? [],
    image: profile.image ?? '',
    form: profile.form ?? false,
    role: 'admin',
  }) as AnyProfile

const AdminCollaboratorPage = () => {
  const navigate = useNavigate()
  const { adminId } = useParams<{ adminId: string }>()
  const { onEditionMode, setOnEditionMode } = useUser()
  const [admin, setAdmin] = useState<AnyProfile | null>(null)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    setOnEditionMode(false)

    if (!adminId) {
      setError('No se encontró el administrador seleccionado.')
      return undefined
    }

    return onSnapshot(
      doc(firestore, 'admin', adminId),
      (snapshot) => {
        if (!snapshot.exists()) {
          setAdmin(null)
          setError('El administrador ya no existe.')
          return
        }

        setAdmin(
          normalizeAdminProfile(
            snapshot.id,
            snapshot.data() as Partial<Person>,
          ),
        )
        setError(null)
      },
      (snapshotError) => {
        console.error('No se pudo cargar el administrador:', snapshotError)
        setError('No se pudo cargar el administrador.')
      },
    )
  }, [adminId, setOnEditionMode])

  useEffect(
    () => () => {
      setOnEditionMode(false)
    },
    [setOnEditionMode],
  )

  return (
    <Section
      title="Editar administrador"
      childrenClass="content-childrens"
      style={{ overflowY: 'auto', maxHeight: 'calc(100vh - 290px)' }}
    >
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          gap: 16,
          marginBottom: 24,
        }}
      >
        <Button
          className="light-grey"
          onClick={() => navigate('/profesores')}
          label="Volver"
          fontSize={14}
        />
        {admin && !onEditionMode && (
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <Button
              className="dark-grey"
              onClick={() => setOnEditionMode(true)}
              label="Editar"
              fontSize={14}
            />
            <DeleteUserButton
              userToDeleteUID={admin.uid}
              userToDeleteRole="admin"
              setActiveUserNull={() => navigate('/profesores')}
            />
          </div>
        )}
      </div>

      {error && <p role="alert">{error}</p>}
      {!error && !admin && <p>Cargando administrador…</p>}
      {admin && (
        <ProfileView
          initialProfile={admin}
          isNewUser={false}
          allowRoleChange={false}
          allowEmailChange={false}
        />
      )}
    </Section>
  )
}

export default AdminCollaboratorPage
